module.exports = __webpack_public_path__ + "static/img/firefox-icon.f20a92c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/browser/firefox-icon.png
// module id = +pnx
// module chunks = 3